import { useState, useEffect } from "react";
import "./LandingPage.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import SearchBar from "./SeacrhBar";
import DisclaimerModal from "../DisclaimerModal";
import { signOut } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";
import CookieConsent from "../CookieConsent";
import { Analytics } from "../../api/analytics";

const LandingPage = () => {
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check session storage when component mounts
    const accepted = sessionStorage.getItem("disclaimerAccepted") === 'true';
    if (!accepted) {
      setShowDisclaimer(true);
    }
  }, []);

  const handleDisclaimerAccept = () => {
    sessionStorage.setItem("disclaimerAccepted", "true");
    setShowDisclaimer(false);
  };

  const handleDisclaimerCancel = async () => {
    try {
      const user = localStorage.getItem("userId");

      sessionStorage.setItem("disclaimerAccepted", "false");
      Analytics.logEvent("rejected_disclaimer", {
        userId: user,
      });

      Analytics.logOut(user);

      await signOut();
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
    }
  }
  return (
    <div className="landing-background page-container">
      {/* Always render modal above all other content */}
      {showDisclaimer && (
        <DisclaimerModal
          handleDisclaimerAccept={handleDisclaimerAccept}
          handleDisclaimerCancel={handleDisclaimerCancel}
        />
      )}

      <Header headerName="" />
      {!showDisclaimer && <CookieConsent />}
      <main className="page-content">
        <div className="advanced-search">
          <div className="main-content">
            <SearchBar />
            <div className="start-search-container">
              <div className="watermark-logo" />
              <p className="start-search-text">Begin your search above</p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
